import { connect } from 'react-redux';
import { fetchStaffLogin } from 'actions/staffs';

let _content = null;

const StaffLogin = (props) => {
  const { fetchStaffLogin, success } = props;
  let selectedStaff = props.location.state
    ? props.location.state.selectedStaff
    : null;
  const onLogin = (formData) => {
    fetchStaffLogin(formData);
  };

  success && localStorage.setItem('staffLoggedIn', JSON.stringify(true));

  return (
    _content &&
    _content({
      props,
      selectedStaff,
      onLogin,
    })
  );
};

const mapStateToProps = (state) => {
  return {
    pending: state.staffs.pending,
    error: state.staffs.error,
    success: state.staffs.loginSuccess,
    currentStore: state.stores.currentStore,
    currentStaff: state.staffs.currentStaff,
    staffs: state.auth.staffs,
  };
};

const mapDispatchToProps = {
  fetchStaffLogin,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(StaffLogin);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/login/staffLogin/index.js